import Form from "./Form.component";


export default Form;